<ul class="list-group" *ngFor="let field of _documentService.fieldList">
  <li class="list-group-item mb-075">{{ field.translate | translate }}: {{ field.label }}</li>
</ul>
